/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomAttributeTypedArgument model module.
 * @module model/CustomAttributeTypedArgument
 * @version V1
 */
class CustomAttributeTypedArgument {
    /**
     * Constructs a new <code>CustomAttributeTypedArgument</code>.
     * @alias module:model/CustomAttributeTypedArgument
     */
    constructor() { 
        
        CustomAttributeTypedArgument.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomAttributeTypedArgument</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomAttributeTypedArgument} obj Optional instance to populate.
     * @return {module:model/CustomAttributeTypedArgument} The populated <code>CustomAttributeTypedArgument</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomAttributeTypedArgument();

            if (data.hasOwnProperty('argumentType')) {
                obj['argumentType'] = ApiClient.convertToType(data['argumentType'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomAttributeTypedArgument</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomAttributeTypedArgument</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['argumentType'] && !(typeof data['argumentType'] === 'string' || data['argumentType'] instanceof String)) {
            throw new Error("Expected the field `argumentType` to be a primitive type in the JSON string but got " + data['argumentType']);
        }

        return true;
    }


}



/**
 * @member {String} argumentType
 */
CustomAttributeTypedArgument.prototype['argumentType'] = undefined;

/**
 * @member {Object} value
 */
CustomAttributeTypedArgument.prototype['value'] = undefined;






export default CustomAttributeTypedArgument;

